import React from 'react';

export default function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-28 border-b border-stone-200 py-20 md:scroll-mt-16">
      <div className="mx-auto max-w-5xl px-5">
        <h2 className="mb-10 text-balance text-2xl font-bold tracking-tight md:text-3xl">{title}</h2>
        {children}
      </div>
    </section>
  );
}
